import { DASHBOARD_APIS_DATA } from "../types";

export interface IDashboardApisData {
  adjustment_options: any;
  client_detail: any;
  default_setting: any;
  global_variable: any;
  rl1_summary: any;
  rl3_summary: any;
  rl16_summary: any;
  t3_summary: any;
  t4_summary: any;
  t4_summary_reduce_ei: any;
  t4a_summary: any;
  t5_summary: any;
  masked_status: boolean;
}

const initialState: IDashboardApisData = {
  adjustment_options: null,
  client_detail: null,
  default_setting: null,
  global_variable: null,
  rl1_summary: null,
  rl3_summary: null,
  rl16_summary: null,
  t3_summary: null,
  t4_summary: null,
  t4_summary_reduce_ei: null,
  t4a_summary: null,
  t5_summary: null,
  masked_status: true, //data is masked
};

export const dashboardApisDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DASHBOARD_APIS_DATA.DASHBOARD_APIS_DATA_SET_SELECTED:
      // return {
      //   ...state,
      //   adjustment_options: action.payload.adjustment_options,
      //   client_detail: action.payload.client_detail,
      //   default_setting: action.payload.default_setting,
      //   global_variable: action.payload.global_variable,
      //   rl1_summary: action.payload.rl1_summary,
      //   rl3_summary: action.payload.rl3_summary,
      //   rl16_summary: action.payload.rl16_summary,
      //   t3_summary: action.payload.t3_summary,
      //   t4_summary: action.payload.t4_summary,
      //   t4_summary_reduce_ei: action.payload.t4_summary_reduce_ei,
      //   t4a_summary: action.payload.t4a_summary,
      //   t5_summary: action.payload.t5_summary,
      // };
      return {
        ...state,
        ...action.payload, // only updates provided keys
      };
    case DASHBOARD_APIS_DATA.DASHBOARD_APIS_DATA_CLEAR_SELECTED:
      return {
        ...state,
        adjustment_options: initialState.adjustment_options,
        client_detail: initialState.client_detail,
        default_setting: initialState.default_setting,
        global_variable: initialState.global_variable,
        rl1_summary: initialState.rl1_summary,
        rl3_summary: initialState.rl3_summary,
        rl16_summary: initialState.rl16_summary,
        t3_summary: initialState.t3_summary,
        t4_summary: initialState.t4_summary,
        t4_summary_reduce_ei: initialState.t4_summary_reduce_ei,
        t4a_summary: initialState.t4a_summary,
        t5_summary: initialState.t5_summary,
        masked_status: initialState.masked_status,
      };
    default:
      return state;
  }
};
